import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getDocument = (req) => {
  try {
    const response = privateAxiosIntance.get(protectedRoutes.document, {
      params: req,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDocumentById = (id) => {
  try {
    console.log("ids", id);
    const response = privateAxiosIntance.get(`${protectedRoutes.document}`, {
      params: id,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteDocument = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(`${protectedRoutes.document}`, {
      data: reqBody,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postDocument = (reqBody) => {
  try {
    const response = privateAxiosIntance.post(
      protectedRoutes.document,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const patchDocument = (reqBody) => {
  try {
    const response = privateAxiosIntance.patch(
      protectedRoutes.document,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
